<script>
import Form from "@/pages/components/assets/_form.vue";
import Modal from "@/pages/components/modal.vue";
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
	mixins: [StoreForm],
	components: {Modal, Form},
	props: {
		id: {
			type: String,
			required: true
		},
		assetableId: {
			type: Number,
			required: true,
		},
		assetableType: {
			type: String,
			required: true,
		},
		assetableGroup: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			table: null,
			method: null
		}
	},
	methods: {
		setTable(table) {
			this.table = table;
			$(this.table.$refs.table).on('editModal', this.editAsset.bind(this));
		},
		newAsset() {
			this.formRoute = route('api.v1.assets.store');
			console.log(42, this.formRoute);
			this.method='POST';
			this.$refs.form.newAsset({
				assetableGroup: this.$props.assetableGroup,
				assetableId: this.$props.assetableId,
				assetableType: this.$props.assetableType
			});
			this.$refs.assetFormModal.open();
		},
		async editAsset(event, data) {
			// Always set the documentId first!

			let asset = await Helpers.Ajax.get(route('api.v1.assets.show', {asset: data.modelId}), {},{success : () => {}});
			this.method='PUT';
			this.$refs.form.setAsset(asset, {
				assetableGroup: this.$props.assetableGroup,
				assetableId: this.$props.assetableId,
				assetableType: this.$props.assetableType
			})
			this.formRoute = route('api.v1.assets.update', {asset: data.modelId});
			this.$refs.assetFormModal.open();
		},
		getFormMethod() {
			return this.method;
		},
		afterSuccess(form, response) {
			this.$refs.assetFormModal.close();
			let $table = $(this.table.$refs.table);
			$table.DataTable({retrieve: true}).ajax.reload();

		},

	}
}
</script>

<template>
	<Modal :id="this.id" ref="assetFormModal" title="Bestand toevoegen" size="lg">
		<form :id="this.id + '_form'" @submit.prevent="submit">
			<Form ref="form"></Form>
		</form>

		<template #footer>
			<span role="button" data-bs-dismiss="modal" class="btn btn-secondary">Annuleren</span>
			<button role="button" type="submit" :form="this.id + '_form'" class="btn btn-primary">Opslaan</button>
		</template>
	</Modal>
</template>
